import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Resources = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Resources' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,3 L21,7.5 L12,12 L3,7.5 L12,3 Z M16.5,10.25 L21,12.5 L12,17 L3,12.5 L7.5,10.25 L7.5,10.25 M16.5,15.25 L21,17.5 L12,22 L3,17.5 L7.5,15.25 L7.5,15.25' />
  </StyledIcon>
);
